import { Temporal } from 'temporal-polyfill';
import type { ContractCancellationDate, ContractExpiryDate } from '@/lib/dates';

export type ContractStatus = 'Active' | 'Expired' | 'Cancelled';

type ContractDates = {
  expiryDate: ContractExpiryDate;
  cancellationDate?: ContractCancellationDate | null;
};

export function deriveContractStatus(
  contract: ContractDates,
  today: Temporal.PlainDate,
): ContractStatus {
  if (contract.cancellationDate) {
    return 'Cancelled';
  }

  return Temporal.PlainDate.compare(contract.expiryDate, today) < 0
    ? 'Expired'
    : 'Active';
}
